import {RequiredLanguageProfile} from './shared-types';
import {SupportedLanguages} from './SupportedLanguages';

export interface Campaign {
  resourceId: string;
  name: string;
  status: CampaignStatus;
  jobPosting: {
    resourceId: string;
    title: string;
  };
  dateRange: {
    startDate: string;
    endDate: string;
  };
  matches: {
    total: number;
  };
}

export enum CampaignStatus {
  Preparation = 'preparation',
  Pending = 'pending_approval',
  Live = 'live',
  Paused = 'paused',
  Optimization = 'optimization',
  Archived = 'archived',
}

const CampaignStatusKeys: Record<CampaignStatus, RequiredLanguageProfile> = {
  [CampaignStatus.Preparation]: {
    en: 'Preparation',
    de: 'Vorbereitung',
  },
  [CampaignStatus.Pending]: {
    en: 'Pending Approval',
    de: 'Ausstehende Freigabe',
  },
  [CampaignStatus.Live]: {
    en: 'Live',
    de: 'Live',
  },
  [CampaignStatus.Paused]: {
    en: 'Paused',
    de: 'Pausiert',
  },
  [CampaignStatus.Optimization]: {
    en: 'Optimization',
    de: 'Optimierung',
  },
  [CampaignStatus.Archived]: {
    en: 'Archived',
    de: 'Archiviert',
  },
};

// Safely get status translation. If key does not exist, just returns the value from backend as the translation
export const getCampaignStatusTranslation = (status: CampaignStatus, lang: SupportedLanguages): string => {
  return CampaignStatusKeys[status]?.[lang] ?? status;
};
